import { captureException } from "@sentry/browser";
import { AxiosInstance } from "axios";
import { Dispatch } from "redux";
import { IPlan } from "../../../../common/types";
import { IPack } from "../../dashboard/models";
import { IStateTree } from "../../interfaces";
import { showNotification } from "../../notification/actions";
import { PackActionTypes } from "../models/packActions";

import { GET_PACK, CHANGE_PACK_SORTING } from "../types";

export default ({ packId, lang }: { packId: string, lang: string }) =>
    async (dispatch: Dispatch<PackActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    dispatch({
        type: GET_PACK,
        payload: {
            loading: true,
        },
    });
    try {
        const res = await api.get<{ plans: IPlan[] }>(`/pack?packId=${packId}`);
        await dispatch({
            type: GET_PACK,
            payload: res,
            packId,
        });
        dispatch({
            type: CHANGE_PACK_SORTING,
            payload: {
                lang,
                sorting: getState().pack.sorting,
            },
        });
    } catch (error) {
        dispatch(showNotification(error.toString(), "warning"));
        captureException(error);
        dispatch({
            type: GET_PACK,
            payload: {
                error: true,
            },
        });
    }
};
